<script setup>
import { computed } from 'vue'
import TableList from '../others/TableList.vue'
import Commons from '@/shared/utils/commons'

const cols = computed(() => [
  {
    name: 'Utilisateur',
    id: 'payerName',
    value(el) {
      const initials = (el.payerName || '??').substring(0, 2).toUpperCase()
      const avatar = `<div class="flex items-center justify-center w-8 h-8 rounded-lg bg-brand-50 text-brand-700 font-bold text-[10px] border border-brand-100 flex-shrink-0">${initials}</div>`
      const sub = el.payerPhone || el.payerEmail || ''
      return [
        `<div class="flex items-center gap-2">${avatar}<span>${el.payerName || '—'}</span></div>`,
        sub,
      ]
    },
  },
  {
    name: 'Date & Réf',
    id: 'date',
    value(el) {
      const date = el.date ? Commons.time(el.date) : '—'
      const ref = el.reference ? `<span class="font-mono text-[10px] text-gray-400 tracking-tighter">${el.reference}</span>` : ''
      return `<div class="flex flex-col gap-0.5"><span class="text-sm text-gray-700">${date}</span>${ref}</div>`
    },
  },
  {
    name: 'Description',
    id: 'description',
    value(el) {
      return `<p class="text-sm text-gray-600 max-w-[200px] truncate" title="${el.description || ''}">${el.description || 'Opération standard'}</p>`
    },
  },
  {
    name: 'Type',
    id: 'type',
    filter: {
      key: 'type',
      default: '',
      options: [
        { name: 'Tous', value: '' },
        { name: 'Dépôt', value: 'credit' },
        { name: 'Retrait', value: 'debit' },
      ],
    },
    value(el) {
      if (el.type === 'credit') {
        return `<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-50 text-emerald-600 border border-emerald-200">▲ Dépôt</span>`
      }
      return `<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-rose-50 text-rose-600 border border-rose-200">▼ Retrait</span>`
    },
  },
  {
    name: 'Montant',
    id: 'amount',
    value(el) {
      const sign = el.type === 'credit' ? '+' : '-'
      const color = el.type === 'credit' ? 'text-emerald-600' : 'text-rose-600'
      return `<span class="font-black italic text-sm ${color}">${sign} ${Commons.formatAmount(el.amount)} ${el.currency || 'XOF'}</span>`
    },
  },
  {
    name: 'Statut',
    id: 'status',
    filter: {
      key: 'status',
      default: '',
      options: [
        { name: 'Tous', value: '' },
        { name: 'Succès', value: 'completed' },
        { name: 'En attente', value: 'pending' },
        { name: 'Échec', value: 'failed' },
      ],
    },
    value(el) {
      const statusMap = {
        completed: { label: 'Succès', cls: 'bg-green-50 text-green-600 border-green-200' },
        paid:      { label: 'Succès', cls: 'bg-green-50 text-green-600 border-green-200' },
        success:   { label: 'Succès', cls: 'bg-green-50 text-green-600 border-green-200' },
        pending:   { label: 'Attente', cls: 'bg-amber-50 text-amber-600 border-amber-200' },
        processing:{ label: 'Attente', cls: 'bg-amber-50 text-amber-600 border-amber-200' },
        failed:    { label: 'Échec', cls: 'bg-rose-50 text-rose-600 border-rose-200' },
        rejected:  { label: 'Échec', cls: 'bg-rose-50 text-rose-600 border-rose-200' },
        cancelled: { label: 'Annulé', cls: 'bg-rose-50 text-rose-600 border-rose-200' },
      }
      const s = statusMap[el.status?.toLowerCase()] || { label: el.status || '—', cls: 'bg-gray-50 text-gray-500 border-gray-200' }
      return `<span class="inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase ${s.cls}">${s.label}</span>`
    },
  },
])
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <TableList
      title="Dépôts & Retraits"
      dataKey="adminTransactions"
      hasSearch
      :cols="cols"
      :refreshOnEvents="['TRANSACTIONS_UPDATED']"
    />
  </div>
</template>
